module.exports = __webpack_public_path__ + "static/media/mcculla.19d5a63a.png";